import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_c6eec58c-238b-4337-9d43-c824e890ecf6/artifacts/f0e7ezix_image_7f0b2b8d.jpg";

const links = [
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Process", href: "#process", testid: "nav-link-process" },
  { label: "Why Us", href: "#why-us", testid: "nav-link-whyus" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-[#0a0f1d]/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3 shrink-0">
          <img
            data-testid="header-logo"
            src={LOGO}
            alt="Majisa Man Power Service"
            className="h-10 sm:h-12 w-auto rounded-md bg-white/95 px-2 py-1 object-contain"
          />
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm font-medium text-slate-300 hover:text-[#d4af37] transition-colors duration-300 tracking-wide uppercase"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="tel:+918079090643"
            data-testid="btn-quick-call"
            className="hidden sm:flex items-center gap-2 text-sm font-semibold text-slate-200 hover:text-[#d4af37] transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            80790 90643
          </a>
          <a
            href="#join"
            data-testid="btn-join-rider"
            className="text-xs sm:text-sm font-bold uppercase tracking-wider bg-[#d4af37] text-[#0a0f1d] px-4 sm:px-5 py-2.5 rounded-sm hover:bg-[#f59e0b] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            Join as Rider
          </a>
        </div>
      </div>
    </motion.header>
  );
};
